import { useMemo } from 'react';

import { ProgressBarItem } from 'components/ProgressBar';
import { useJobContext } from 'pages/Job/context';

export interface ProgressSidebarHook {
  items: ProgressBarItem[];
  isLoading: boolean;
}

export default function useProgressSidebar(): ProgressSidebarHook {
  const { page, paymentType, changesStatus, isLoading } = useJobContext();

  const items: ProgressBarItem[] = useMemo(
    () => [
      changesStatus
        ? {
            type: 'multi',
            title: 'Review Quote',
            substeps: [
              {
                title: 'Await Changes',
                active: changesStatus === 'REQUESTED',
                type: 'single',
              },
              {
                title: 'Review Changes',
                active: changesStatus === 'REVIEW',
                type: 'single',
              },
            ],
          }
        : {
            type: 'single',
            title: 'Review Quote',
            active: page === 'QUOTE',
          },
      paymentType === 'FINANCE'
        ? {
            type: 'multi',
            title: 'Choose Payment',
            substeps: [
              {
                title: 'Choose Rate',
                active: page === 'CHECKOUT',
                type: 'single',
              },
              {
                title: 'Apply For Finance',
                active: false,
                type: 'single',
              },
              {
                title: 'Await Decision',
                active: false,
                type: 'single',
              },
              {
                title: 'Complete Purchase',
                active: false,
                type: 'single',
              },
            ],
          }
        : {
            type: 'single',
            title: 'Choose Payment',
            active: page === 'CHECKOUT',
          },
      {
        type: 'single',
        title: 'Complete',
        active: page === 'COMPLETE',
      },
    ],
    [page, paymentType, changesStatus],
  );

  return {
    items,
    isLoading,
  };
}
